module.exports = __webpack_public_path__ + "components/modal-app-popup/static/firefox-icon-7a747a0d1a7eb8da66b2112840c6cf7a.webp";